/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Error_No_EdgesInputs */

const cs_workflow_error_no_edges = /** @type {(inputs: Workflow_Error_No_EdgesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propojte uzly spojeními.`)
};

const en_workflow_error_no_edges = /** @type {(inputs: Workflow_Error_No_EdgesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect the nodes with edges.`)
};

/**
* | output |
* | --- |
* | "Connect the nodes with edges." |
*
* @param {Workflow_Error_No_EdgesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_error_no_edges = /** @type {((inputs?: Workflow_Error_No_EdgesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Error_No_EdgesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_error_no_edges(inputs)
	return cs_workflow_error_no_edges(inputs)
});